import { render, staticRenderFns } from "./imgInfo.vue?vue&type=template&id=13804fa0&scoped=true&"
import script from "./imgInfo.vue?vue&type=script&lang=js&"
export * from "./imgInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13804fa0",
  null
  
)

export default component.exports